
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {IRouteStop} from '@/model/Route/routeInterfaces';
import RouteLocationPickerMap, {IPickerLocation} from '@/components/route/RouteLocationPickerMap.vue';

const routeModule = namespace('routeModule');

@Component({components: {RouteLocationPickerMap}})
export default class RouteExtraStopDialog extends Vue {
  @Prop({default: false}) protected value!: boolean;
  @Prop({default: null}) protected stop!: IRouteStop | null;

  @routeModule.Getter('mapsApiKey') protected mapsApiKey!: string;

  protected form = {
    name:    '',
    address: '',
    lat:     0,
    lng:     0,
  };

  protected get internalOpen(): boolean {
    return this.value;
  }

  protected set internalOpen(val: boolean) {
    this.$emit('input', val);
  }

  protected get canSaveForm(): boolean {
    return !!this.form.name && !!this.form.address && this.form.lat !== 0 && this.form.lng !== 0;
  }

  @Watch('value')
  protected onValueChanged(val: boolean) {
    if (val) {
      this.resetForm();
    }
  }

  protected resetForm() {
    this.form = {
      name:    this.stop && this.stop.name ? this.stop.name : '',
      address: this.stop && this.stop.address ? this.stop.address : '',
      lat:     this.stop && this.stop.lat ? this.stop.lat : 0,
      lng:     this.stop && this.stop.lng ? this.stop.lng : 0,
    };
  }

  protected onMapChange(loc: IPickerLocation) {
    this.form.lat     = loc.lat;
    this.form.lng     = loc.lng;
    this.form.address = loc.address;
  }

  protected saveStop() {
    if (!this.canSaveForm) { return; }

    this.$emit('save', {
      name:    this.form.name,
      address: this.form.address,
      lat:     this.form.lat,
      lng:     this.form.lng,
    });
    this.internalOpen = false;
  }
}
